import {
  PortalAdditionalReportGroupViewModel,
  PortalAdditionalReportViewModel,
} from "../../../../generated/data-contracts";
import { ReportsListReportItem } from "./ReportsListReportItem";

interface IReportsListGroupItemProps {
  reportGroup: PortalAdditionalReportGroupViewModel;
  selectedReport: PortalAdditionalReportViewModel | undefined;
  setSelectedReport: (
    report: PortalAdditionalReportViewModel | undefined,
  ) => void;
}

export function ReportsListGroupItem(
  props: Readonly<IReportsListGroupItemProps>,
) {
  const { reportGroup, selectedReport, setSelectedReport } = props;

  return (
    <div className="report-list-group col-3">
      <h4>{reportGroup.name}</h4>
      <div>
        {reportGroup.reports?.map((item) => (
          <ReportsListReportItem
            key={item.portalAdditionalReportId}
            isSelected={
              selectedReport?.portalAdditionalReportId ==
              item.portalAdditionalReportId
            }
            report={item}
            setSelectedReport={setSelectedReport}
          />
        ))}
      </div>
    </div>
  );
}
